import { render, staticRenderFns } from "./StatusSettings.vue?vue&type=template&id=0a4a61d6"
import script from "./StatusSettings.vue?vue&type=script&lang=js"
export * from "./StatusSettings.vue?vue&type=script&lang=js"
import style0 from "./StatusSettings.vue?vue&type=style&index=0&id=0a4a61d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports